import axios from "axios";
import {IUser} from "../../../pages/user-management/models/User";
import {makeRequest} from "../../../utils/helpers/helperMethods/makeRequest";

export async function getClients() {
    try{
        return await axios.get("http://localhost:3000/clients");
    }catch (e) {
        throw "Clients get Failed"
    }
}

export async function signUp(user:IUser,url: string, accessToken: string) {
    try {
        const response = await  ( await  makeRequest(accessToken, url, 'POST', user, ''));
        return response;
    }catch (e) {
        throw "SignUp failed"
    }
}

export async function signIn(instance:any){
    try{
        
    }catch (e:any) {
        if (e.response.status === 401){
            throw "Login Failed. Wrong Username or Password";
        }else if (e.response.status === 500){
            throw "Login Failed. Server Error";
        }else{
            throw e.message;
        }
    }
}

export async function ForgetPassword(email:string) {
    try {
        return await axios.get(`${process.env.REACT_APP_INFINITYS_API}/api/v1/Authenticate/forgetpassword?Username=${email}`);
    }catch (e) {
        throw "Forget Password Failed"
    }
}

export async function ChangePassword(userName:any, oldPassword:string, newPassword:string, token:string) {
    try {
        return await axios.put(`${process.env.REACT_APP_INFINITYS_API}/api/v1/Authenticate/resetpassword`,
            {
                userName:userName,
                oldPassword: oldPassword,
                newPassword: newPassword
            }, {
                headers: {
                    "Authorization": token
                }
            }
        );
    }catch (e:any) {
        if (e.message === "Network Error"){
            throw "Network Error";
        }else{
            if (e.message == "Request failed with status code 500"){
                if (e.response.data.message == "! Please check user details & try again."){
                    throw "Please check current password & try again"
                }else{
                    throw "Server Error"
                }
            }else{
                throw "Password reset failed"
            }
        }
    }
}

export async function getUserTypes(token:string,) {
    try {
        return await axios.get(`${process.env.REACT_APP_INFINITYS_API}/api/v1/UserTypes/getall`,
            {
                headers:{
                    "Authorization" : token
                }
            })
    }catch (e) {
        throw "User Types get failed"
    }
}

export async function getUserStatus(token:string,) {
    try {
        return await axios.get(`${process.env.REACT_APP_INFINITYS_API}/api/v1/getall`,
            {
                headers:{
                    "Authorization" : token
                }
            })
    }catch (e) {
        throw "User Types get failed"
    }
}

export async function getLoggedUserData(username: string, token:string) {
    try {
        return await axios.get(`${process.env.REACT_APP_INFINITYS_API}/api/v1/Authenticate/getuser?UserName=${username}`,
            {
                headers:{
                    "Authorization" : token
                }
            })
    }catch (e) {
        throw "User Types get failed"
    }
}
